const ASSET = /#asset#(.+)#(.+)/;

export const Regex = {
  DOMAIN:
    /(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?:\.\w+)?/,
  IPV4: /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/,
  IPV6: /(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}/,
  CIDR: /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(?:3[0-2]|[12]?[0-9])/,
  GIT_ORG: /https:\/\/github\.com\/([a-zA-Z\d-]+)/,
  EMAIL: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/,
  CVE_ID: /CVE-\d{4}-\d{4,7}/,
  AWS_REGION_REGEX: /.*execute-api.(.*).amazonaws/,
  IMAGE: /.*\.(jpg|jpeg|png|gif|bmp)$/,
  CONTAINS_ASSET: new RegExp(`.*(${ASSET.source})`),
  PASSWORD: {
    CHARACTERS_LENGTH: /(?=.{16,})/,
    UPPER_CASE: /[A-Z]/,
    LOWER_CASE: /[a-z]/,
    NUMERIC_CHARACTERS: /\d/,
    SPECIAL_CHARACTERS: /[^\w\s]/,
  },
  ATTRIBUTE_KEY: /^#attribute#([^#]+)(?:#(.*))?/,
  CUSTOM_ALERT_KEY: /^#condition##attribute#/,
  RISK_ATTRIBUTE_VALUE: /^#attribute#([^#]+)#([^#]+)#/,
  RISK: /^#risk#([^#]+)#([^#]+)/,
  TECHNOLOGY: /^#technology#([^#]+)/,
  MATERIAL_RISK: /^#risk#-#([^#]+)/,
  SEED: /^#seed#([^#]+)#([^#]+)/,
  PRAETORIAN_ACCOUNT: /@praetorian\.com$/,
  PRESEED_KEY: /^#preseed#([^#]+)#([^#]+)#([^#]+)/,
  MANAGED_ACCOUNT: /^chariot\+.*@praetorian\.com$/,
};

export const AllowedSeedRegex = new RegExp(
  `(${Regex.DOMAIN.source})|(${Regex.CIDR.source})|(${Regex.IPV4.source})|(${Regex.IPV6.source})|(${Regex.GIT_ORG.source})`,
  'g'
);
